import { render, staticRenderFns } from "./_SourcePicker.vue?vue&type=template&id=5f16b40c&scoped=true&"
import script from "./_SourcePicker.vue?vue&type=script&lang=js&"
export * from "./_SourcePicker.vue?vue&type=script&lang=js&"
import style0 from "./_SourcePicker.vue?vue&type=style&index=0&id=5f16b40c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16b40c",
  null
  
)

export default component.exports